import React from 'react';

export class TableHead extends React.Component<React.PropsWithChildren> {
  public render() {
    return <thead>{this.props.children}</thead>;
  }
}

export default TableHead;
